import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { LikehoodMasterService } from './likehood-master.service';

@Component({
  selector: 'app-likehood-to-purchase-master',
  templateUrl: './likehood-to-purchase-master.component.html',
  styleUrls: ['./likehood-to-purchase-master.component.css'],
})
export class LikehoodToPurchaseMasterComponent implements OnInit {
  isLoading = new BehaviorSubject<boolean>(false);
  displayedColumns: string[] = [
    'SNo',
    'interest',
    'createdAt',
    'updatedAt',
    'status',
    'action',
  ];
  bucketurl = environment.bucketUrl;
  public ELEMENT_DATA: any[] = [];
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public selectedId: number | null = null;
  likHoodMaster: FormGroup;
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);

  constructor(
    private likeHoodService: LikehoodMasterService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.likHoodMaster = this.fb.group({
      status: ['', Validators.required],
      interest: ['', Validators.required],
    });
  }

  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.getLikeHoodMasterData();
  }

  clearForm() {
    this.submitted = false;
    this.likHoodMaster.patchValue({
      status: '',
      interest: '',
    });
    this.selectedId = null;
  }

  get f() {
    return this.likHoodMaster.controls;
  }

  ngOnInit() {
    this.getLikeHoodMasterData();
  }

  getLikeHoodMasterData() {
    this.isLoading.next(true);
    this.likeHoodService.getLikeHoodMaster().subscribe(
      (response) => {
        this.ELEMENT_DATA = response.body.data;
        this.dataSource.data = this.ELEMENT_DATA;
        this.isLoading.next(false);
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }

  onSubmit() {
    this.submitted = true;

    if (this.likHoodMaster.invalid) {
      return;
    }

    this.isLoading.next(true);

    if (this.isEdit) {
      if (this.selectedId !== null) {
        this.likeHoodService
          .updateLikeHoodlMaster(this.selectedId, this.likHoodMaster.value)
          .subscribe(
            (response) => {
              let responseData = response.body;
              if (responseData.responseCode == 200) {
              this.toastr.success('Like Hood Master updated successfully');
              this.clearForm();
              this.isEdit = false;
              this.getLikeHoodMasterData();
              this.isLoading.next(false);
            }else {
              this.isLoading = new BehaviorSubject<boolean>(false);
              this.isLoading.next(false);
              this.toastr.error(response.body.responseMessage);
            }
            },
            (error) => {
              this.toastr.error('Error updating Like Hood Master');
              this.isLoading.next(false);
            }
          );
      }
    } else {
      this.likeHoodService
        .createLikehoodMaster(this.likHoodMaster.value)
        .subscribe(
          (response) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
            this.toastr.success('Like Hood  Master created successfully');
            this.clearForm();
            this.isCreate = false;
            this.getLikeHoodMasterData();
            this.isLoading.next(false);
            } else {
              this.isLoading.next(false);
              this.toastr.error(response.body.responseMessage);
            }
          },
          (error) => {
            this.toastr.error('Error creating Level Master');
            this.isLoading.next(false);
          }
        );
    }
  }

  edit(element: any) {
    this.isEdit = true;
    this.isCreate = false;
    this.selectedId = element.id;
    this.likHoodMaster.patchValue({
      status: element.status ? 1 : 0,
      interest: element.interest,
    });
  }

  public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const interest = data.interest.toLowerCase().includes(filter);
      return interest;
    };
      this.dataSource.filter = filterValue;
  }
   clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
